/* eslint-disable no-nested-ternary */
import React, { Fragment, forwardRef } from 'react'
import PropTypes from 'prop-types'
import Typography from '@mui/material/Typography'
import { Grid } from '@mui/material'

import { HtmlTooltip } from '../components'
import { isDebug } from './functions'

export const DebugView = forwardRef((props, ref) => {
  const _isDebug = isDebug()
  const type = props.type || '- UNKNOWN -'
  const obj = props.children || null

  if (!obj) {
    return null
  }

  return _isDebug ? (
    obj?.name || obj?.id ? (
      <HtmlTooltip
        style={{ width: 'auto' }}
        ref={ref}
        title={
          <Fragment>
            <Typography
              color="inherit"
              style={{
                marginBottom: '25px',
                height: '25px',
                fontSize: '16px',
                fontWeight: '600',
                borderBottom: '4px dashed rgba(255,255,255,0.15)'
              }}
            >
              <b
                style={{
                  padding: '3px 7px',
                  background: 'rgba(0,0,0,0.80)',
                  color: 'rgba(255,255,255,0.4)',
                  borderRadius: '3px',
                  marginRight: '6px'
                }}
              >
                {String(type).replace(/\s$/, '').toLocaleUpperCase().replace(/_/, ' ')}
              </b>
              {obj?.name || obj?.id || 'NO-NAME'}
            </Typography>
            <Grid container={true} spacing={2} direction="row" style={{ padding: '0px 15px' }}>
              {/* KEYS */}
              <Grid item={true} xs={6} sm={6}>
                <Grid container={true} spacing={2} direction="column">
                  {Object.keys(obj).map((key, index) => (
                    <Grid
                      key={`debug-tooltip-key-${index}-${obj?.id}`}
                      item={true}
                      xs={6}
                      sm={6}
                      style={{ borderBottom: '0.5px solid rgba(255,255,255,0.15)', padding: '6px 0 6px 8px' }}
                    >
                      <b>{key}</b>
                    </Grid>
                  ))}
                </Grid>
              </Grid>

              {/* VALUES */}
              <Grid item={true} xs={6} sm={6}>
                <Grid container={true} spacing={2} direction="column">
                  {Object.values(obj).map((val, index) => (
                    <Grid
                      key={`debug-tooltip-val-${index}-${obj?.id}`}
                      item={true}
                      xs={6}
                      sm={6}
                      style={{
                        borderBottom: '0.5px solid rgba(255,255,255,0.15)',
                        width: '250px',
                        padding: '6px 0 6px 10px'
                      }}
                    >
                      {
                        <em className={obj?.id === val ? '__DEBUG_UUID__' : ''}>
                          {val ? (
                            typeof val === 'boolean' ? (
                              <b style={{ borderRadius: '20px', background: '#777', padding: '2px 6px' }}>
                                {val ? 'TRUE' : 'FALSE'}
                              </b>
                            ) : typeof val === 'object' ? (
                              JSON.stringify(val)
                            ) : (
                              val
                            )
                          ) : (
                            <b style={{ color: 'red' }}>{'- N/A -'}</b>
                          )}
                        </em>
                      }
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Fragment>
        }
      >
        <div className="__DEBUG_UUID__">{obj?.id}</div>
      </HtmlTooltip>
    ) : (
      <div className="__DEBUG_UUID__">{obj?.id}</div>
    )
  ) : null
})

DebugView.displayName = 'DebugView'

DebugView.propTypes = {
  type: PropTypes.oneOf([
    'project',
    'scenario',
    'flow_group',
    'flow',
    'resources',
    'variables',
    'products',
    'weather_data',
    'locations',
    'parameters'
  ]),
  children: PropTypes.any
}
